import { API } from '../Auth';

// Admin calls
const getUsers = async () => {
    console.log('getUsers');
    try {
        const api = 'api';
        const path = '/users';
        const response = await API.get(api, path);
        return response;
    } catch (error) {
        throw error;
    }
}

const addUser = async (email, password, role) => {
    try {
        const api = 'api';
        const path = '/users';
        // `password` is optional: when omitted the backend creates the user and emails an
        // invite link (the 201 response carries inviteEmailSent: true|false).
        const body = {
            email: email,
            role: role
        };
        if (password) {
            body.password = password;
        }
        const params = { body };
        const response = await API.post(api, path, params);
        return response;
    } catch (error) {
        throw error;
    }
}

// Admin: email the user a reset/invite link so they can set their own password.
// 200 {"sent":true} on success; 422 {"sent":false,"error":"..."} surfaces as ApiError.
const sendInvite = async (userId) => {
    try {
        const api = 'api';
        const path = `/users/${userId}/invite`;
        const response = await API.post(api, path, {});
        return response;
    } catch (error) {
        throw error;
    }
}

// Unauthenticated deployment flags (e.g. emailEnabled) — gates the email-based admin UI.
const getDeploymentConfig = async () => {
    try {
        const api = 'api';
        const path = '/api/config/deployment';
        const response = await API.get(api, path);
        return response;
    } catch (error) {
        throw error;
    }
}

const deleteUser = async (user) => {
    console.log('deleteUser');
    try {
        const api = 'api';
        const path = '/users';
        const params = {
            body: {
                username: user
            }
        };
        const response = await API.del(api, path, params);
        return response;
    } catch (error) {
        // Rethrow the ApiError as-is: getErrorMessage reads the server's reason off its body.
        throw error;
    }
}

const modifyUser = async (user, attributes) => {
    // console.log('modifyUser');
    // console.log('USER', user);
    // console.log('ATTRIBUTES', attributes);
    try {
        const api = 'api';
        const path = '/users/admin';
        const params = {
            body: {
                username: user,
                ...attributes
            }
        };
        const response = await API.put(api, path, params);
        return response;
    } catch (error) {
        throw error;
    }
}

// Set any role (USER / ADMIN / READONLY). PUT /users/admin only toggles ADMIN <-> USER.
// The API refuses (400) to demote the last admin.
const updateUserRole = async (user, role) => {
    const api = 'api';
    const path = `/users/${user.id}`;
    const params = { body: { email: user.email, role } };
    return API.put(api, path, params);
}

const resetUserPassword = async (userId, newPassword) => {
    try {
        const api = 'api';
        const path = `/users/${userId}/reset-password`;
        const params = {
            body: {
                newPassword: newPassword
            }
        };
        const response = await API.post(api, path, params);
        return response;
    } catch (error) {
        throw new Error(error?.response?.data?.message || error?.response?.data || error.message);
    }
}

const getDiscoverySettings = async () => {
    try {
        const api = 'manager';
        const path = '/api/admin/discovery-settings';
        const response = await API.get(api, path);
        return response;
    } catch (error) {
        throw error;
    }
}

const saveDiscoverySettings = async (enabled, intervalMinutes) => {
    try {
        const api = 'manager';
        const path = '/api/admin/discovery-settings';
        const params = {
            body: {
                enabled: enabled,
                intervalMinutes: intervalMinutes
            }
        };
        const response = await API.put(api, path, params);
        return response;
    } catch (error) {
        throw new Error(error?.response?.data?.message || error.message);
    }
}

export { getUsers, addUser, deleteUser, modifyUser, updateUserRole, resetUserPassword, sendInvite, getDeploymentConfig, getDiscoverySettings, saveDiscoverySettings }